<form [formGroup]="form">
  <ng-content></ng-content>
</form>
